import PropTypes from "prop-types"
import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

import { setImageLoading } from "areas/product/store/actions"
import { cn } from "styles/utils"

import ProductImagePreview from "./product-image-preview"

const ProductImage = ({ className = "", sizes, src, srcSet, ...props }) => {
  const wizardLoading = useSelector((state) => state.wizard.loading)
  const imageLoading = useSelector((state) => state.previewImageUI.imageLoading)

  const isLoadingPreview = !!wizardLoading || imageLoading

  const dispatch = useDispatch()

  const handleImageLoading = useCallback(
    (loading) => {
      dispatch(setImageLoading(loading))
    },
    [dispatch]
  )

  return (
    <ProductImagePreview
      className={cn(
        "tablet:max-w-(--tablet-width) desktop:max-w-(--desktop-max-width) mx-auto block",
        isLoadingPreview && "bg-white opacity-50",
        className
      )}
      isLoadingPreview={isLoadingPreview}
      setIsLoadingPreview={handleImageLoading}
      sizes={sizes}
      src={src}
      srcSet={srcSet}
      style={{
        "--desktop-max-width": "500px",
        "--tablet-max-width": "325px",
      }}
      {...props}
    />
  )
}

ProductImage.propTypes = {
  className: PropTypes.string,
  sizes: PropTypes.string,
  src: PropTypes.string,
  srcSet: PropTypes.string,
}

export default ProductImage
